/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedDealerDetailsHeader_seller$ref = any;
type PdpSharedDealerDistinctions_seller$ref = any;
type PdpSharedDealerInfo_seller$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedDealerDetailsStats_seller$ref: FragmentReference;
export type PdpSharedDealerDetailsStats_seller = {|
  +$fragmentRefs: PdpSharedDealerDistinctions_seller$ref & PdpSharedDealerInfo_seller$ref & PdpSharedDealerDetailsHeader_seller$ref,
  +$refType: PdpSharedDealerDetailsStats_seller$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedDealerDetailsStats_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDistinctions_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerInfo_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_seller",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '384526cc2be7cdf66ac7436802f0eb25';
module.exports = node;
